import { Request } from 'app/utils';
import { Log, UserManager, WebStorageStateStore } from 'oidc-client';

import { getStore } from 'app/store';
import { setAuthInfo } from 'app/auth/store/loginSlice';
import { userLoggedOut } from 'app/auth/store/userSlice';

const {
  REACT_APP_AUTHORITY,
  REACT_APP_CLIENT_ID,
  REACT_APP_SILENT_REDIRECT_URI,
  REACT_APP_REDIRECT_URI,
  REACT_APP_POST_LOGOUT_REDIRECT_URI,
  REACT_APP_RESPONSE_TYPE,
  REACT_APP_SCOPE,
  REACT_APP_AUDIENCE
} = process.env;

const settings = {
  loadUserInfo: true,
  automaticSilentRenew: true,
  authority: REACT_APP_AUTHORITY,
  client_id: REACT_APP_CLIENT_ID,
  silent_redirect_uri: REACT_APP_SILENT_REDIRECT_URI,
  redirect_uri: REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: REACT_APP_POST_LOGOUT_REDIRECT_URI,
  response_type: REACT_APP_RESPONSE_TYPE,
  scope: REACT_APP_SCOPE,
  extraQueryParams: {
    audience: REACT_APP_AUDIENCE
  }
};

export const _UserManager = new UserManager({
  ...settings,
  userStore: new WebStorageStateStore({ store: window.localStorage })
});

Log.logger = console;
Log.level = Log.INFO;

const _store = () => getStore();

const _authStore = () => {
  return _store().getState()?.auth?.login;
};

export const _setAuthorizationToken = token => {
  Request.setAuthorization(token);
};

const _updateAuthInfo = result => {
  const { access_token } = result;
  console.log('Updating auth info: ', result);

  _store().dispatch(setAuthInfo(result));
  _setAuthorizationToken(access_token);
};

export const login = () => {
  return _UserManager.signinRedirect();
};

export const renewToken = () => {
  _setAuthorizationToken(null);
  return _UserManager
    .signinSilent()
    .then(res => {
      _updateAuthInfo(res);
    })
    .catch(e => {
      logout();
    });
};

export const logout = () => {
  return _UserManager.signoutRedirect().then(res => {
    _store().dispatch(userLoggedOut());
  });
};

export const signInRedirectCallback = () => {
  return _UserManager.signinRedirectCallback().then(user => {
    _updateAuthInfo(user);
  });
};

export const signInSilentCallback = () => {
  return _UserManager.signinSilentCallback();
};

export const signoutRedirectCallback = () => {
  return _UserManager.signoutRedirectCallback().then(res => {
    _store().dispatch(userLoggedOut());
  });
};

export const _getUser = async () => {
  const user = await _UserManager.getUser();
  console.log('auth Service user==>', user);

  return user;
};

/* Auth manager */

const _accessTokenExpire = () => {
  return _authStore()?.tokenExpire;
};

const _canRenewToken = () => {
  return Number((Date.now() / 1000).toFixed(0)) < _authStore()?.tokenExpire;
};

export const isLoggedIn = () => {
  return !!_authStore()?.token && _canRenewToken();
};

const _shouldRenewToken = () => {
  return Number((Date.now() / 1000).toFixed(0)) > _accessTokenExpire();
};

export const renew = () => {
  // _setAuthorizationToken(null);
  return renewToken();
};

export const init = async accessToken => {
  let tmpToken = accessToken;

  // if not logged in or refresh token has expired we'll reject directly
  if (isLoggedIn()) {
    // if access token is expired, renew token
    // p.s: _renew method will update token properly
    if (_shouldRenewToken()) {
      return await renewToken();
    } else {
      // everything is okay, we know this guy
      tmpToken = accessToken || _authStore().token;

      _setAuthorizationToken(tmpToken);
      // _setTimeout();
      return tmpToken;
    }
  } else {
    return null;
  }
};
